import { render, staticRenderFns, recyclableRender, components } from "./test.vue?vue&type=template&id=25722d30&scoped=true&"
var renderjs
import script from "./test.vue?vue&type=script&lang=js&"
export * from "./test.vue?vue&type=script&lang=js&"
import style0 from "./test.vue?vue&type=style&index=0&id=25722d30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_@dcloudio_vue-cli-plugin-uni@2.0.0-28320200727001@@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25722d30",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/index/test.vue"
export default component.exports